import React from 'react'
import { store } from '../../../store'
import { t } from '../../../config/i18n'
import { routes } from '../../../config/routes'
import { Button, Checkbox, Form, Input } from 'antd'
import { PERMISSIONS } from '../../../models/AbstractCatalogConfig'
import { observer } from 'mobx-react'
import { useParams } from 'react-router'
import { ruleExtraId } from '../../../lib/utilsForm'
import { useNavigate } from '../../../hooks/useNavigate'
import { ExtraFieldFormValues } from '../../shared/ui/ExtraFieldFormValues'
import { formValuesToEntity, hasAccess } from '../../../lib/utilsCatalogs'
import { AbstractCatalogService } from '../../../services/AbstractCatalogService'
import { TAbstractCatalogItem } from '../../../models/AbstractCatalogItem'

interface Props {
  catalogService: AbstractCatalogService<any, any>
}

export const PageCatalogItemDetailTabMain = observer(({ catalogService }: Props) => {
  const navigate = useNavigate()
  const params = useParams()
  const { type, id } = params
  const parentId = parseInt(`${params.parentId}`) || 0
  const config = catalogService.store.configItemDetails
  const item = catalogService.store.itemDetails
  const [formValues, setFormValues] = React.useState<TObjectAny>()
  const showFields = !(formValues?.isCategory ?? item.isCategory)

  const saveItem = async (item: TAbstractCatalogItem, restore = false) => {
    if (await catalogService.saveCatalogItem(item, restore)) {
      catalogService.loadCatalogItems(config.id).catch(window.logger.error)
      navigate(routes.catalogItemList, { type, id: id || '', parentId })
    }
  }

  const onSubmit = async (values: TObjectAny) => {
    const nextItem = formValuesToEntity(config, item, values)
    nextItem.parentId = parentId || 0
    await saveItem(nextItem)
  }

  const onRestore = async () => {
    await saveItem(item, true)
  }

  if (store.ui.loading) {
    return null
  }

  const disabled = !item.active || !hasAccess(config, PERMISSIONS.ITEM_UPDATE)

  return (
    <>
      <Form
        key={item._id}
        disabled={disabled}
        layout={'vertical'}
        labelCol={{ span: 12 }}
        wrapperCol={{ span: 12 }}
        initialValues={item || {}}
        autoComplete="off"
        onValuesChange={(_, values) => setFormValues(values)}
        onFinish={onSubmit}
      >
        <Form.Item
          label={t.catalog.nameEl}
          name="name"
          rules={[{ required: true }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label={'ExtraID'}
          name="extraId"
          rules={[{ required: true }, ruleExtraId]}
        >
          <Input />
        </Form.Item>

        {showFields && (
          <ExtraFieldFormValues
            config={config}
            fields={item.fields}
          />
        )}

        <Form.Item
          name="isCategory"
          label="isCategory"
          valuePropName="checked"
        >
          <Checkbox disabled={!!item.id} />
        </Form.Item>

        {catalogService.type === 'single' && (
          <Form.Item
            name="displayInWeb"
            label="displayInWeb"
            valuePropName="checked"
          >
            <Checkbox />
          </Form.Item>
        )}

        {item.active && (
          <Form.Item>
            <Button type="primary" htmlType="submit">
              {t.common.save}
            </Button>
          </Form.Item>
        )}
      </Form>

      {!item.active && (
        <Button type="primary" onClick={onRestore}>
          {t.common.restore}
        </Button>
      )}
    </>
  )
})
